<template>
  <base-material-chart-card
    id="food-chart"
    :data="foodChartData"
    :options="foodChart.options"
    :responsive-options="responsiveOptions"
    color="#06948a"
    hover-reveal
    type="Bar"
    class="pb-10"
  >
    <template v-slot:reveal-actions>
      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-bind="attrs" color="info" icon v-on="on">
            <v-icon color="info">mdi-refresh</v-icon>
          </v-btn>
        </template>

        <span>Refresh</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ attrs, on }">
          <v-btn v-bind="attrs" light icon v-on="on">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <span>Change Date</span>
      </v-tooltip>
    </template>

    <h4 class="card-title font-weight-light mt-2 ml-2 text-center">Portions for {{ diaryDateFormatted }}</h4>

    <!-- <p class="d-inline-flex font-weight-light ml-2 mt-1">
            Last Campaign Performance
    </p>-->
    <v-row>
      <v-col cols="4" md="2" v-for="portion in foodAllowancesUsed" :key="portion.n">
        <div class="ml-auto text-center" :class="{ 'error--text': portion.u > portion.a }">
          <div class="body-3 font-weight-light" v-text="portion.n"></div>
          <span class="display-2 font-weight-light">{{ (portion.u).toFixed(2).replace(/[.,](00)|0$/, '') }}</span>
          <span class="grey--text"> of {{ portion.a }}</span>
        </div>
      </v-col>
    </v-row>

    <slot name="foodbody" />

    <!-- <template v-slot:actions>
            <v-icon
              class="mr-1"
              small
            >
              mdi-clock-outline
            </v-icon>
            <span class="caption grey--text font-weight-light">updated 10 minutes ago</span>
    </template>-->
  </base-material-chart-card>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "FoodChartCard",

  data() {
    return {
      responsiveOptions: [
        [
          "screen and (max-width: 640px)",
          {
            seriesBarDistance: 0,
            axisX: {
              labelInterpolationFnc: function(value) {
                return value[0];
              }
            }
          }
        ]
      ]
    };
  },

  methods: {
    ...mapActions("Diary", ["subscribeToFoodDiary", "subscribeToWeightDiary"])
  },
  computed: {
    ...mapState("Diary", ["foodDiary"]),
    ...mapState("Profile", ["profile", "currentDiet"]),
    ...mapGetters("Diary", ["foodAllowancesUsed"]),
    diaryDateFormatted() {
       if (moment().format('YYYYMMDD') == moment(this.diaryDate).format('YYYYMMDD')) {
         return 'Today'
       } else {        
         return moment(this.diaryDate).format('D MMM YYYY')
       }
    },
    foodChart() {
      return {
        options: {
          axisX: {
            showGrid: false,
            offset: 30
          },
          axisY: {
            labelInterpolationFnc: function(value) {
              return `${value}%`;
            }
          },
          low: 0,
          high: 100,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        }
      };
    },
    foodChartData() {
      //const foodLabels = this.currentDiet.g.map(a => a.n)
      return {
        labels: this.foodAllowancesUsed.map(p => p.n), //['Carbs', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju'],
        series: [this.foodAllowancesUsed.map(p => (p.u / p.a) * 100)]
      };
    }
  },
  mounted: function() {
    this.subscribeToFoodDiary();
  },
  props: {
    diaryDate: {
      type: String,
      default: () => moment().format('YYYY-MM-DD'),
    },
  }
};
</script>
<style >
.ct-series-a .ct-bar {
  stroke-width: 20;
}
</style>